<script setup lang="ts">
import type { TestimonialsComponentModel } from '@su4r-frontend/api';
defineProps<TestimonialsComponentModel>();
</script>

<template>
    <section class="tile flex flex-col gap-y-4 bg-white lg:gap-6">
        <header class="flex flex-col gap-4">
            <h2 v-if="title" class="order-2 text-3xl lg:text-4xl">{{ title }}</h2>
            <h3 v-if="subtitle" class="font-body order-1">{{ subtitle }}</h3>
        </header>

        <div class="lg:grid-cols-auto-fit grid grid-cols-1 gap-y-4 lg:gap-6">
            <TestimonialItem
                v-for="(item, index) in testimonials"
                :key="`item-${index}`"
                v-bind="item" />
        </div>
    </section>
</template>
